import { format } from 'date-fns';

const formatDate = (date: string | Date, shortMonth?: boolean, includeTime?: boolean) => {
  try {
    const dateString = typeof date === 'string' ? new Date(date) : date;
    const monthFormat = shortMonth ? 'MMM' : 'MMMM';
    const timeFormat = includeTime ? ' HH:mm' : '';
    return format(dateString, `dd ${monthFormat} yyyy${timeFormat}`);
  } catch (error) {
    return '';
  }
};

export default formatDate;
